<label class="grid cursor-pointer place-items-center">
  <input
    type="checkbox"
    class="toggle col-span-2 col-start-1 row-start-1"
    (change)="handleThemeChange($event)"
    [checked]="darkModeEnabled"
  />
  <app-sun-icon
    class="col-start-1 row-start-1 h-5 w-5"
    [svgClass]="darkModeEnabled ? 'stroke-base-content' : 'stroke-base-100'"
  ></app-sun-icon>
  <app-moon-icon
    class="col-start-2 row-start-1 h-5 w-5"
    svgClass="fill-base-100"
  ></app-moon-icon>
</label>
